import { create } from 'zustand';

const useNonProfitSignUpPopUpStore = create((set) => ({
  open: false,
  nonProfit: {},
  redirectPage: null,
  setOpen: (open, nonProfit, redirectPage) =>
    set(() => ({
      open: open,
      nonProfit: nonProfit || null,
      redirectPage: redirectPage || null,
    })),
}));

export default useNonProfitSignUpPopUpStore;
